import React from 'react'
import styled from 'styled-components'
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom'
import { FaSearch, FaArrowLeft } from 'react-icons/fa'

const SearchProducts = () => {
  return (
    <>
      <Helmet>
        <title>Search Moved | Medichy</title>
        <meta
          name="description"
          content="Product search page - Find medical equipment by model number or SKU"
        />
      </Helmet>
      <TheSearchProducts>
        <div className="container">
          <div className="search-card">
            <div className="search-icon-wrapper">
              <FaSearch />
            </div>
            <h1>Product Moved</h1>
            <p>Search for products using model number or SKU to find your equipment</p>
            <div className="button-group">
              <Link to="/products" className="btn-primary">
                Browse All Products
              </Link>
              <Link to="/" className="btn-secondary">
                <FaArrowLeft />
                Back to Home
              </Link>
            </div>
            <div className="search-tip">
              <span>💡 Tip:</span>
              <p>You can search for products by Model Number or SKU on our products page</p>
            </div>
          </div>
        </div>
      </TheSearchProducts>
    </>
  )
}

const TheSearchProducts = styled.div`
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #edf2f7 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;

  .container {
    width: 100%;
    max-width: 600px;
    margin: 0 auto;
  }

  .search-card {
    background: white;
    border-radius: 20px;
    padding: 3rem 2rem;
    text-align: center;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
    animation: fadeInUp 0.5s ease;

    @keyframes fadeInUp {
      from {
        opacity: 0;
        transform: translateY(30px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }

    .search-icon-wrapper {
      width: 80px;
      height: 80px;
      background: linear-gradient(135deg, #3182ce 0%, #2c5282 100%);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto 1.5rem;

      svg {
        font-size: 2.5rem;
        color: white;
      }
    }

    h1 {
      font-size: 2rem;
      font-weight: 700;
      color: #1a1a1a;
      margin-bottom: 1rem;
    }

    p {
      font-size: 1rem;
      color: #4a5568;
      line-height: 1.6;
      margin-bottom: 2rem;
    }

    .button-group {
      display: flex;
      gap: 1rem;
      justify-content: center;
      margin-bottom: 2rem;
      flex-wrap: wrap;

      .btn-primary {
        display: inline-flex;
        align-items: center;
        gap: 0.5rem;
        background: linear-gradient(135deg, #3182ce 0%, #2c5282 100%);
        color: white;
        padding: 0.875rem 1.75rem;
        font-size: 0.95rem;
        font-weight: 600;
        border-radius: 8px;
        text-decoration: none;
        transition: all 0.3s ease;

        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 20px rgba(49, 130, 206, 0.3);
        }
      }

      .btn-secondary {
        display: inline-flex;
        align-items: center;
        gap: 0.5rem;
        background: transparent;
        color: #3182ce;
        border: 2px solid #3182ce;
        padding: 0.875rem 1.75rem;
        font-size: 0.95rem;
        font-weight: 600;
        border-radius: 8px;
        text-decoration: none;
        transition: all 0.3s ease;

        &:hover {
          background: #3182ce;
          color: white;
          transform: translateY(-2px);
        }
      }
    }

    .search-tip {
      background: #f0f9ff;
      padding: 1rem;
      border-radius: 12px;
      text-align: left;
      display: flex;
      gap: 0.75rem;
      align-items: flex-start;
      border-left: 4px solid #3182ce;

      span {
        font-weight: 700;
        color: #3182ce;
        font-size: 0.9rem;
        flex-shrink: 0;
      }

      p {
        font-size: 0.85rem;
        color: #4a5568;
        margin: 0;
        line-height: 1.5;
      }
    }
  }

  /* Media Queries */
  @media screen and (max-width: 1366px) {
    padding: 2rem 1.5rem;

    .search-card {
      padding: 2.5rem 1.8rem;
    }
  }

  @media screen and (max-width: 1200px) {
    .search-card {
      max-width: 550px;
    }
  }

  @media screen and (max-width: 900px) {
    padding: 2rem 1.5rem;

    .search-card {
      padding: 2rem 1.5rem;

      .search-icon-wrapper {
        width: 70px;
        height: 70px;

        svg {
          font-size: 2rem;
        }
      }

      h1 {
        font-size: 1.75rem;
      }

      p {
        font-size: 0.95rem;
      }
    }
  }

  @media screen and (max-width: 600px) {
    padding: 1.5rem;

    .search-card {
      padding: 1.75rem 1.25rem;

      .search-icon-wrapper {
        width: 60px;
        height: 60px;
        margin-bottom: 1rem;

        svg {
          font-size: 1.75rem;
        }
      }

      h1 {
        font-size: 1.5rem;
        margin-bottom: 0.75rem;
      }

      p {
        font-size: 0.9rem;
        margin-bottom: 1.5rem;
      }

      .button-group {
        gap: 0.75rem;
        margin-bottom: 1.5rem;

        .btn-primary,
        .btn-secondary {
          padding: 0.7rem 1.25rem;
          font-size: 0.85rem;
        }
      }

      .search-tip {
        padding: 0.875rem;

        span {
          font-size: 0.85rem;
        }

        p {
          font-size: 0.8rem;
        }
      }
    }
  }

  @media screen and (max-width: 420px) {
    padding: 1rem;

    .search-card {
      padding: 1.5rem 1rem;

      .search-icon-wrapper {
        width: 55px;
        height: 55px;

        svg {
          font-size: 1.5rem;
        }
      }

      h1 {
        font-size: 1.35rem;
      }

      p {
        font-size: 0.85rem;
      }

      .button-group {
        flex-direction: column;
        width: 100%;

        .btn-primary,
        .btn-secondary {
          width: 100%;
          justify-content: center;
          padding: 0.7rem;
        }
      }

      .search-tip {
        flex-direction: column;
        gap: 0.5rem;

        span {
          font-size: 0.8rem;
        }

        p {
          font-size: 0.75rem;
        }
      }
    }
  }

  @media screen and (max-width: 350px) {
    padding: 0.75rem;

    .search-card {
      padding: 1.25rem 0.875rem;

      .search-icon-wrapper {
        width: 50px;
        height: 50px;
        margin-bottom: 0.75rem;

        svg {
          font-size: 1.35rem;
        }
      }

      h1 {
        font-size: 1.2rem;
      }

      p {
        font-size: 0.8rem;
        margin-bottom: 1.25rem;
      }

      .button-group {
        gap: 0.6rem;
        margin-bottom: 1.25rem;

        .btn-primary,
        .btn-secondary {
          padding: 0.6rem;
          font-size: 0.8rem;
        }
      }

      .search-tip {
        padding: 0.75rem;

        span {
          font-size: 0.75rem;
        }

        p {
          font-size: 0.7rem;
        }
      }
    }
  }
`;

export default SearchProducts;